import { NgModule } from '@angular/core';
import { HtmlParserPipe } from './html-parser';

@NgModule({
  declarations: [
    HtmlParserPipe
  ],
  imports: [ ],
  exports: [
    HtmlParserPipe
  ]
})
export class HtmlParserModule {}



// WEBPACK FOOTER //
// ./src/pipes/html-parser/html-parser.module.ts